import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import {
  GoogleDocumentMetadataParam,
  GoogleDocumentMetadataModel,
  GoogleDocumentProcessingDataByTeamParam,
  GoogleDocumentProcessingStatusParam,
  GoogleDocumentCreationApiModel,
  GrantUserPermissionParam,
} from "@plugins/google/types.ts";
import { CONTEXT } from "@plugins/google/google.constant.ts";

const uploadPdfAttachmentToDrive = async (
  requestData: Partial<GoogleDocumentCreationApiModel>,
): Promise<ApiResponse<GoogleDocumentMetadataModel>> => {
  return await httpClient.post(`/apis/question-answer-google-document/upload`, requestData);
};

export default {
  uploadPdfAttachmentToDrive,
  createGoogleAttachment(
    param: Partial<GoogleDocumentCreationApiModel>,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    return httpClient.post(`/apis/google-document/create`, param);
  },
  createGoogleAttachmentInStudentAttempt(
    param: Partial<GoogleDocumentCreationApiModel>,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    return httpClient.post(`/apis/question-answer-google-document/create`, param);
  },
  createGoogleAttachmentInNotebook(
    param: Partial<GoogleDocumentCreationApiModel>,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    return httpClient.post(`/apis/notebook-google-document/create`, param);
  },
  checkDocumentStatus(param: GoogleDocumentProcessingStatusParam): Promise<ApiResponse<boolean>> {
    const params = {
      params: {
        lessonUuid: param.lessonUuid,
        recordType: param.recordType,
      },
    };
    return httpClient.get(
      `/apis/google-document/processing/status/${param.googleDocumentId}`,
      params,
    );
  },
  checkDocumentStatusInStudentAttempt(
    param: GoogleDocumentProcessingStatusParam,
  ): Promise<ApiResponse<boolean>> {
    const params = {
      params: {
        lessonUuid: param.lessonUuid,
      },
    };
    return httpClient.get(
      `/apis/question-answer-google-document/processing/status/${param.googleDocumentId}/${param.academicYear}`,
      params,
    );
  },
  getDocumentProcessingDataInStudentAttemptByTeam(
    param: GoogleDocumentProcessingDataByTeamParam,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    return httpClient.get(
      `/apis/question-answer-google-document/get-processing-data/${param.sourceDocumentId}/${param.teamId}/${param.academicYear}`,
    );
  },
  getAttachmentMeta(
    requestData: GoogleDocumentMetadataParam,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    const param = {
      lessonUuid: requestData.lessonUuid,
      googleDocumentId: requestData.googleDocumentId,
      recordType: CONTEXT.LESSON.toUpperCase(), // TODO: [Google] standard to uppercase, rename the context to align with backend
    };
    return httpClient.post(`/apis/google-document/get-metadata`, param);
  },
  getAttachmentMetaInStudentAttempt(
    requestData: GoogleDocumentMetadataParam,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    const param = {
      lessonUuid: requestData.lessonUuid,
      googleDocumentId: requestData.googleDocumentId,
      academicYear: requestData.academicYear,
      recordType: CONTEXT.ATTEMPT.toUpperCase(),
    };
    return httpClient.post(`/apis/google-document/get-metadata`, param);
  },

  getAttachmentNotebookMeta(
    requestData: GoogleDocumentMetadataParam,
  ): Promise<ApiResponse<GoogleDocumentMetadataModel>> {
    const param = {
      googleDocumentId: requestData.googleDocumentId,
      recordType: CONTEXT.NOTEBOOK.toUpperCase(),
      lessonUuid: requestData.notebookUuid,
    };
    return httpClient.post(`/apis/google-document/get-metadata`, param);
  },
  grantUserPermission(param: Partial<GrantUserPermissionParam>): Promise<ApiResponse<boolean>> {
    return httpClient.get(`/apis/google-document/user/grant-permission`, { params: param });
  },
  grantUserPermissionInStudentAttempt(
    param: Partial<GrantUserPermissionParam>,
  ): Promise<ApiResponse<boolean>> {
    return httpClient.get(`/apis/question-answer-google-document/user/grant-permission`, {
      params: param,
    });
  },
  grantUserPermissionInNotebook(
    param: Partial<GrantUserPermissionParam>,
  ): Promise<ApiResponse<boolean>> {
    return httpClient.get(`/apis/notebook-google-document/user/grant-permission`, {
      params: param,
    });
  },
};
